import $ from 'jquery'

const getCarouselSlide = (item, i) => {
  const index = i + 1
  const imageUrl = `img/carousel/${index}/${item.images[0]}`
  return `<div class="item" data-index="${index}" data-popup="popup-${index}">
    <div class="item_inner__wrapper">
      <div class="visual" style="background-image: url(${imageUrl})"></div>
      <div class="number">${index}</div>
      <div class="location">${item.location}</div>
      <div class="name">${item.name}</div>
    </div>
  </div>`
}

const initCarousel = (content) => {
  $('#carousel').html(content)
  $('#carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })
}

const initPopup = (item, i) => {
  const index = i + 1
  let content = `<div class="popup" id="popup-${index}">
    <div class="popup_inner">
    <div class="popup_carousel" style="margin-bottom:8px">`
  item.images.forEach(url => {
    const imageUrl = `img/carousel/${index}/${url}`
    content += `<div class="slide" style="width: 100%; display: inline-block;">
      <div class="visual test" style="background-image: url(${imageUrl});"></div>
    </div>`
  })
  content += `</div>
      <span class="rank"><span class="rank_number"></span></span>
      <div class="popup_content">
        <h2>${item.name}</h2>
        <span class="location">${item.location}</span>
        <span>Distance (miles): ${item.distance}</span>
        <span>Elevation Gain (feet): ${item.elevation}</span>
        <span>
          <a href="${item.instagram}" class="tag" target="_blank">${item.hashtag}</a>
          <span>used <span class="number_of_use">${item.ranking}</span> times</span>
        </span>
        <div class="rating">`
  const stars = item.stars
  if (stars && (stars | 0) > 0) {
    let j = 0
    for (j = 0; j < (stars | 0); j++) {
      content += '<div class="star"></div>'
    }
    if ((stars % 1 >= 0.5)) {
      content += '<div class="star star_half"></div>'
    }
  }
  content += `</div>
      </div>
      <div class="close" style="background-image: url('img/close_cross.svg');"></div>
    </div>
  </div>`
  $('#main').append(content)
}

const initPopupCarousel = (target) => {
  if ($(target).is('.slick-initialized')) {
    $(target).slick('unslick')
  }
  $(target).not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  })
}

const initCarouselEvent = () => {
  $('#carousel .item').on('click', (e) => {
    const popup = $(e.currentTarget).attr('data-popup')
    $('.popup').removeClass('active')
    $('#' + popup).addClass('active')
    initPopupCarousel(`#${popup} .popup_carousel`)
  })
}

const initPopupClose = () => {
  $('.popup .close').on('click', () => {
    $('.popup').removeClass('active')
  })
}

const popupCarouselStyles = () => {
  const styles = `<style>
    .popup .slick-prev {
      left: 10px;
      z-index: 1;
    }
    .popup .slick-next {
      right: 10px;
      z-index: 1;
    }
  </style>`
  $('#main').prepend(styles)
}

export default {
  getCarouselSlide,
  initCarousel,
  initPopup,
  initPopupCarousel,
  initCarouselEvent,
  popupCarouselStyles,
  initPopupClose,
}
